var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.64844 20.678H4.62612L4.6039 20.68C4.38779 20.6993 4.05662 20.6521 3.79403 20.4646C3.55926 20.2969 3.31641 19.9734 3.31641 19.2969V6.9375H4.14844V19.2969V19.7969H4.64844H17.0407V20.678H4.64844Z",
    stroke: "#8593ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.79796 14.202H17.9306C18.0932 14.202 18.2152 14.1275 18.2965 13.9784C18.3778 13.8293 18.3643 13.687 18.2559 13.5514L16.0194 10.5627C15.9381 10.4543 15.8296 10.4001 15.6941 10.4001C15.5585 10.4001 15.4501 10.4543 15.3688 10.5627L13.2543 13.3888L11.7498 11.376C11.6685 11.2675 11.56 11.2133 11.4245 11.2133C11.2889 11.2133 11.1805 11.2675 11.0992 11.376L9.47266 13.5514C9.36422 13.687 9.35067 13.8293 9.43199 13.9784C9.51332 14.1275 9.63531 14.202 9.79796 14.202ZM8.17144 17.4551C7.72415 17.4551 7.3411 17.2959 7.02231 16.9777C6.70405 16.6589 6.54492 16.2759 6.54492 15.8286V4.44293C6.54492 3.99563 6.70405 3.61259 7.02231 3.29379C7.3411 2.97553 7.72415 2.81641 8.17144 2.81641H19.5571C20.0044 2.81641 20.3874 2.97553 20.7062 3.29379C21.0245 3.61259 21.1836 3.99563 21.1836 4.44293V15.8286C21.1836 16.2759 21.0245 16.6589 20.7062 16.9777C20.3874 17.2959 20.0044 17.4551 19.5571 17.4551H8.17144Z",
    fill: "#8593ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.af1ca1b2ed77bfc03a4b6c4365922d2f.svg";
export { ForwardRef as ReactComponent };